module.exports = __webpack_public_path__ + "static/media/Eventos_ayuda.50224230.svg";